import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const NetworkList = Loadable(lazy(() => import('pages/network/List')));
const NetworkView = Loadable(lazy(() => import('pages/network/View')));
const NetworkEdit = Loadable(lazy(() => import('pages/network/Edit')));
const NetworkCreate = Loadable(lazy(() => import('pages/network/Create')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const NetworkRoutes: RouteObject = {
    path: 'network',
    children: [
        {
            path: '',
            element: <NetworkList />,
        },
        {
            path: ':id',
            element: <NetworkView />,
        },
        {
            path: ':id/edit',
            element: <NetworkEdit />,
        },
        {
            path: 'new',
            element: <NetworkCreate />,
        },
    ],
};
export default NetworkRoutes;
